<form [formGroup]="userForm">
    <div class="page-main-header"
         [class.open]="open">

        <div class="main-header-right row">
            <div class="d-lg-none col-2">

            </div>
            <div class="main-header-left text-center d-lg-none col-8 ">
                <div class="logo-wrapper">
                    <a [routerLink]="'/dashboard'"><img class="blur-up lazyloaded"
                             src="assets/images/dashboard/swayam.png"
                             alt=""></a>
                </div>
            </div>
            <div class="mobile-sidebar col-lg-8 col-2 d-flex justify-content-lg-between justify-content-end">
                <div class="media-body switch-sm">
                    <label class="switch">
                        <a>
                            <app-feather-icons id="sidebar-toggle"
                                               [icon]="'align-left'"
                                               (click)="collapseSidebar()">
                            </app-feather-icons>
                        </a>
                    </label>
                </div>
                <!--   <div class="d-block d-sm-none nav-right2">
                    <ul class="nav-menus ">
                        <li class="onhover-dropdown ">

                            <div class="media align-items-center text-uppercase">
                                <h6 class="mb-0">{{parentData?.email?.slice(0, 2) }}</h6>
                            </div>
                            <ul class="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
                                <li>
                                    <a href="javascript:void(0)"
                                       [routerLink]="'/get-help'">
                                        <app-feather-icons [icon]="'settings'"></app-feather-icons><span class="ms-2">
                                            Get Help</span>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="openConfirm()">
                                        <app-feather-icons [icon]="'log-out'"></app-feather-icons><span
                                              class="ms-2">Logout</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div> -->
            </div>
            <div class="nav-right col-lg-4">

                <ul class="nav-menus flex-wrap-reverse-sm"
                    [ngClass]="{'open' : openNav}">
                    <!--    <li>
                    <form class="form-inline search-form">
                        <div class="form-group">
                            <input class="form-control-plaintext"
                                   [class.open]="isOpenMobile"
                                   type="search"
                                   placeholder="Search..">
                            <span class="d-sm-none mobile-search">
                                <app-feather-icons [icon]="'search'"
                                                   (click)="isOpenMobile=!isOpenMobile">
                                </app-feather-icons>
                            </span>
                        </div>
                    </form>
                </li> -->
                    <li class="li-menu">
                        <div class="form-group">
                            <label class="float-label"
                                   for="childid">Select Child</label>
                            <select class="fs-14 form-select"
                                    formControlName="childid"
                                    id="childid">
                                <option [value]="null">
                                    {{'Select Child'}}</option>
                                <option *ngFor="let item of this.parentData?.child_list|keyvalue"
                                        [value]="item.key">
                                    {{item.value}}</option>
                            </select>
                        </div>
                    </li>
                    <li class="li-menu">
                        <div class="form-group">
                            <label class="float-label"
                                   for="deviceid">Select Device</label>
                            <select class="fs-14 form-select"
                                    id="deviceid"
                                    formControlName="deviceid">
                                <option [value]="null">
                                    {{'Select Device'}}</option>
                                <option *ngFor="let item of childrenData?.device_list|keyvalue"
                                        [value]="item.key">
                                    {{item.value}}</option>
                            </select>
                        </div>
                    </li>
                    <!--    <li>
                        <a href="javascript:void(0)"
                           class="text-dark"
                           toggleFullscreen>
                            <app-feather-icons [icon]="'maximize-2'"></app-feather-icons>
                        </a>
                    </li> -->

                    <!--    <li class="onhover-dropdown d-none d-sm-block">

                        <div class="media align-items-center text-uppercase">
                            <h6 class="mb-0">{{parentData?.email?.slice(0, 2) }}</h6>
                        </div>
                        <ul class="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
                            <li>
                                <a href="javascript:void(0)"
                                   [routerLink]="'/get-help'">
                                    <app-feather-icons [icon]="'settings'"></app-feather-icons>Get Help
                                </a>
                            </li>
                            <li>
                                <a (click)="openConfirm()">
                                    <app-feather-icons [icon]="'log-out'"></app-feather-icons>Logout
                                </a>
                            </li>
                        </ul>
                    </li> -->
                </ul>
                <!--   <div class="d-lg-none mobile-toggle pull-right me-2"
                     (click)="openMobileNav()">
                    <app-feather-icons [icon]="'more-horizontal'"></app-feather-icons>
                </div> -->
            </div>
        </div>

    </div>
</form>